<template>
    <div class="portfolio-manager-tab">
        <AonContainer fluid>
            <AonRow class="mt-md w-100">
                <AonSpinner
                    v-if="entityStore.loadingEntity || !entityStore.entity"
                    class="mx-auto"
                    :scale="0.5"
                    color="castleMoat"
                />
                <div v-else class="grid-holder w-100">
                    <AonCol class="grid-cols-12">
                        <div class="tab-cal-holder display-flex justify-between w-100">
                            <AonTabs
                                class="light"
                                :tabs="portfolioTabs"
                                :current-tab="currentTab"
                                @tab-change="tabChange"
                            />
                            <div
                                v-show="currentTab === 1"
                                class="range-holder display-flex align-items-center"
                            >
                                <p class="font-bold mr-sm" style="width: 160px">
                                    Target Date Range:
                                </p>
                                <MoatDatePickerRange />
                            </div>
                        </div>
                    </AonCol>
                    <KeepAlive>
                        <Overview v-if="currentTab === 1" @pass-filters="passFiltersToPatentList" />
                    </KeepAlive>
                    <KeepAlive>
                        <Groom v-if="currentTab === 2" :passed-filters="passedFilters" />
                    </KeepAlive>
                </div>
            </AonRow>
        </AonContainer>
    </div>
</template>

<script setup>
import { computed, ref, watchEffect, nextTick } from 'vue'
import { useEntityStore } from '@/stores'

import Overview from '@/components/company/proTabs/portfolioManager/Overview.vue'
import Groom from '@/components/company/proTabs/portfolioManager/Groom.vue'
import MoatDatePickerRange from '@/components/company/proTabs/helpers/MoatDatePickerRange.vue'

const entityStore = useEntityStore()

const currentTab = ref(1)
const portfolioTabs = ref([
    {
        text: 'Overview',
        value: 'overview',
        id: 1,
    },
    {
        text: 'Portfolio',
        value: 'groom',
        id: 2,
    },
])
const passedFilters = ref({})

const tabChange = (tab) => {
    currentTab.value = tab.id
}

const passFiltersToPatentList = async (data) => {
    currentTab.value = 2
    await nextTick()
    const newData = data.originalData ? data.originalData : data
    passedFilters.value = {
        prune: {
            value: false,
        },
        ...newData,
    }
}
</script>
